import { useState, useCallback } from 'react';

const useModal = () => {
  const [modal, setModal] = useState({
    isVisible: false,
    data: null,
  });

  const show = useCallback((data) => {
    setModal(state => ({ ...state, data, isVisible: true }));
  }, []);

  const hide = useCallback(() => {
    setModal(state => ({ ...state, isVisible: false }));
  }, []);

  return {
    show,
    hide,
    data: modal.data,
    isVisible: modal.isVisible,
  };
};

export default useModal;
